export default "__VITE_ASSET__B65YZ2kx__"